import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./slick.css";
import "./slick-theme.css";
import "./App.css";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import About from "./pages/About";

import OfficeInterior from "./pages/0ffice-interior";

import HomeInterior from "./pages/HomeInterior";
import Furnituresolutions from "./pages/Furnituresolutions"


function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/home-interior" element={<HomeInterior />} />
        <Route path="/office-interior" element={<OfficeInterior />} />
        <Route path="/furniture-solutions" element={<Furnituresolutions />} />

      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
